
// For Custom Confirm Dialog Preset
const leaveEdit = {
  title: '確認',
  text: '変更内容が保存されていません。移動しますか？',
  persistent: true,
  actions: [
    { key: true, text: 'はい', color: 'primary' },
    {
      key: false,
      text: 'いいえ',
      color: '#AEAEAE',
      props:{
        style: { color: '#FFFFFF' }
      }
    },
  ]
}

const deleteConfirm = {
  title: '確認',
  text: '本当に削除しますか？',
  persistent: true,
  actions: [
    { key: true, text: 'はい', color: 'error' },
    {
      key: false,
      text: 'いいえ',
      color: '#AEAEAE',
      props:{
        style: { color: '#FFFFFF' }
      }
    },
  ]
}

const yesNoConfirm = {
  title: '確認',
  text: '{customMessage}',
  persistent: true,
  actions: [
    { key: true, text: 'はい', color: 'primary' },
    {
      key: false,
      text: 'いいえ',
      color: '#AEAEAE',
      props:{
        style: { color: '#FFFFFF' }
      }
    }
  ]
}

export default {
  leaveEdit,
  deleteConfirm,
  yesNoConfirm,
  baseConfirm: {
    title: '確認',
    text: '{customMessage}',
    persistent: true,
    actions: [
      { key: true, text: 'OK', color: 'primary' },
      {
        key: false,
        text: 'キャンセル',
        color: '#AEAEAE',
        props:{
          style: { color: '#FFFFFF' }
        }
      }
    ]
  }
}
